<template>
  <div class="orgDetail">
    <div class="left-box">
      <leftPage :active="5"/>
    </div>
    <div class="right-box">
      <div class="title-box">
        <div class="tit-left">
          <div class="icon-box">
            <i class="iconfont icon-yujing"></i>
          </div>
          <b>风险预警</b>
        </div>
        <div class="btn" @click="dialogVisible = true">添加风险预警</div>
      </div>

      <div class="list ">
        <el-table
          :data="tableData"
          :header-cell-style="centerbgc"
          :cell-style="textCenter"
          style="width: 100%">
          <el-table-column
            label="是否存在经营异常"
            width="170">
            <template slot-scope="scope">
              {{scope.row.is_jingying_yichang | is_yes}}
            </template>
          </el-table-column>
          <el-table-column
            label="是否存在税务异常"
            width="170">
            <template slot-scope="scope">
              {{scope.row.is_shuiwu_yichang | is_yes}}
            </template>
          </el-table-column>
          <el-table-column
            width="170"
            label="是否存在资金异动">
            <template slot-scope="scope">
              {{scope.row.is_zijin | is_yes}}
            </template>
          </el-table-column>
          <el-table-column
            width="170"
            label="是否存在大额资金异动">
            <template slot-scope="scope">
              {{scope.row.is_zijin_dae | is_yes}}
            </template>
          </el-table-column>
          <el-table-column
            width="170"
            label="是否存在舆情信息">
            <template slot-scope="scope">
              {{scope.row.is_yuqing | is_yes}}
            </template>
          </el-table-column>
          <el-table-column
            width="170"
            label="是否存在涉诉情况">
            <template slot-scope="scope">
              {{scope.row.is_shesu | is_yes}}
            </template>
          </el-table-column>
          <el-table-column
            width="170"
            label="是否存在意识形态问题">
            <template slot-scope="scope">
              {{scope.row.is_yishi | is_yes}}
            </template>
          </el-table-column>
          <el-table-column
            width="200"
            label="是否存在资金监管风险信息">
            <template slot-scope="scope">
              {{scope.row.is_zijinfengxian | is_yes}}
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope" class="flex">
              <div class="edit pointer" @click="edit(scope)">编辑</div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="page-box">
        <el-pagination
          :current-page.sync="search.page"
          :page-size="search.limit"
          :total="search.total"
          background
          class="page-all margin-top self-end"
          layout="prev, pager, next"
          @current-change="list">
        </el-pagination>
      </div>
    </div>
    <riskDialog :dialogVisible="dialogVisible" :id="id" @handleClose="handleClose" />
  </div>
</template>
<script>
import leftPage from "@/views/home/common/leftPage";
import riskDialog from "@/views/home/dialog/riskDialog";
import {
  feng_lst
} from "@/api";
import {findByType} from "@/utils/utils";
import {isYes} from "@/utils/const";
export default {
  name: "orgDetail",
  data() {
    return {
      dialogVisible:false,
      id:'',
      tableData:[],
      search:{
        page:1,
        limit:10,
        total:0,
      }
    }
  },
  components: {
    leftPage,
    riskDialog
  },
  computed: {
    textCenter(){
      return {
        textAlign: 'center'
      }
    },
    centerbgc(){
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  created() {
    this.$emit("setActive", {
      headActive: 2
    })
    this.list()
  },
  methods: {
// 获取列表
    async list() {
      this.loading = true
      let _data = await feng_lst(
        this.search.page,
        this.search.limit
      );
      this.loading = false
      if (_data.status === 200) {
        this.tableData = _data.data.data
        this.search.total = _data.data.total
      } else {
        this.$message.error(_data.msg)
      }
    },

    edit(scope){
      this.id = scope.row.id
      this.dialogVisible = true
    },

    handleDelete(id) {
      this.$confirm('此操作将删除该数据，是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.expertDel(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    handleClose(){
      this.dialogVisible = false
      this.id = ''
      this.list()
    },
  },
  watch: {},
  filters: {
    is_yes(val){
      return findByType(isYes, val)
    }
  }
}
</script>

<style scoped lang="scss">
.orgDetail {
  width: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;
  display: flex;
  justify-content: flex-start;

  .right-box {
    flex: 1;
    margin-left: 25px;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #edf6ff 100%);
    border-radius: 8px;
    border: solid 1px #ffffff;
    padding: 0 20px;

    .list {
      width: 100%;
      padding-top: 30px;
    }

    .title-box {
      width: 100%;
      height: 60px;
      border-bottom: solid 2px #e3e7f0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .btn {
        width: 180px;
        height: 40px;
        background-image: linear-gradient(0deg,
          #2791ff 0%,
          #81b6ff 100%);
        border-radius: 5px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        letter-spacing: 1px;
        color: #ffffff;
        cursor: pointer;
        margin-left: 30px;
      }
      .tit-left {
        display: flex;
        justify-content: flex-start;
        padding-top: 25px;

        padding-bottom: 15px;

        .icon-box {
          width: 30px;
          height: 30px;
          background-image: linear-gradient(-30deg,
            #3579fb 0%,
            #44a3ff 100%);
          box-shadow: 0px 10px 10px 0px
          rgba(50, 150, 255, 0.3);
          border-radius: 10px;
          text-align: center;
          line-height: 30px;
          i {
            font-size: 19px;
            color: #ffffff;
          }
        }

        b {
          font-size: 22px;
          color: #16181d;
          font-weight: bold;
          margin-left: 5px;
        }
      }
    }

    .edit {
      font-size: 14px;
      color: #0089ff;
      padding: 4px 10px;
      display: inline-block;
    }
    .del {
      font-size: 14px;
      color: #ff0000;
      padding: 4px 10px;
      display: inline-block;
    }
  }

  .left-box {
    width: 260px;
  }
}
</style>


